import React from 'react'

export default function MeetingAbout({meetAbout}) {
    return (
        <>
        <section className="meetpage-about">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="meetabout-detail">
                            <p>{meetAbout?.para}</p>
                            <img src={meetAbout?.image1} alt="event" className="img-responsive" loading="lazy"/>
                        </div>
                    </div>
                </div>
            </div>

            <img src={meetAbout?.image2} alt="event" className='meetabout-image' loading="lazy"/>
        </section>
        </>
    )
}
